export type OpenDataStatus = "loading" | "success" | "error";

export async function fetchOpenData() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10_000);
  try {
    const result = await fetch("/api/open-data", {
      headers: { Accept: "application/json" },
      signal: controller.signal,
    });
    if (!result.ok || !result.headers.get("content-type")?.includes("application/json")) {
      return null;
    }
    const response = await result.json();
    return {
      oneStepPrice: Number(response?.oneStepPrice) || 0,
      sweatPrice: ["number", "string"].includes(typeof response?.sweatPrice)
        ? Number(response.sweatPrice) || 0
        : 0,
    };
  } catch {
    return null;
  } finally {
    clearTimeout(timeout);
  }
}

export function formatLivePrice(price: number, status: OpenDataStatus): string | null {
  if (status !== "success" || !Number.isFinite(price) || price <= 0) return null;
  const formatted = price.toFixed(7);
  return Number(formatted) > 0 ? formatted : null;
}
